import React from "react"

const Main = ({ children }) => {
  return (
    <main className="main">
      {children}
    </main>
  )
}

export default Main
